<template>
  <div>
    <v-card class="shadow">
      <v-card-title>
        <v-row no-gutters justify="space-between">
          <v-col cols="auto">
            <span class="text-h6 font-weight-regular grey--text text--darken-2">Monthly Active Player Statistics</span>
          </v-col>
          <v-col cols="auto" class="text-right">
            <v-btn
              outlined
              small
              class="text-capitalize font-weight-regular px-2 grey--text text--darken-2"
              @click="filterDialog = true"
              :disabled="activePlayerMonthlyLoading"
            >
              {{ activePlayerMonthly.label }}
              <v-icon small class="ps-1">mdi-chevron-down</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row dense v-if="activePlayerMonthly.active_players_monthly_average">
          <v-col class="my-0" v-if="!playersNewStatisticsLoading && !activePlayerMonthlyLoading">
            <span>Monthly Average <span style="color: #4DD0E1">{{ moneyFormat(parseInt(activePlayerMonthly.active_players_monthly_average)) }}</span></span><br/>
            <span>Lowest <span v-if="!activePlayerMonthlyLoading" style="color: #4DD0E1">{{ moneyFormat(parseFloat(lowest)) }}</span></span><br/>
            <span>Highest <span v-if="!activePlayerMonthlyLoading" style="color: #4DD0E1">{{ moneyFormat(parseFloat(highest)) }}</span></span><br/>
            <span>Percentage vs Registered <span style="color: #4DD0E1">{{ moneyFormat2(parseFloat((activePlayerMonthly.active_players_monthly_average / playersNewStatistics['registered'][0]['registered_player']) * 100)) }}%</span></span><br/>
            <span>Percentage vs YTD Target <span style="color: #4DD0E1">{{ moneyFormat2(parseFloat((activePlayerMonthly.active_players_monthly_average / this.playersNewStatistics.target_as_of_registration.target) * 100)) }}%</span></span>
          </v-col>
        </v-row>

        <div v-if="activePlayerMonthlyLoading" class="text-center">
          <v-progress-circular
            :size="70"
            :width="5"
            color="secondary"
            indeterminate
          ></v-progress-circular>
        </div>
        <div v-else>
          <LineChart :theChartData="activePlayerMonthly" />
        </div>
      </v-card-text>
    </v-card>

    <v-dialog
      ref="filterDialog"
      v-model="filterDialog"
      persistent
      width="290px"
    >
      <v-date-picker
        v-model="year"
        :active-picker.sync="activePicker"
        full-width
        reactive
        no-title
        @click:year="saveFilter"
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="cancelFilter"
        >
          Cancel
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import formatDatev2 from "@/helpers/formatDatev2"
import LineChart from "@/components/dashboard/active_player_statistics/ActivePlayerMonthlyLineChart"

export default {
  components: { LineChart },
  data: () => ({
    year: formatDatev2((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), 'format', 'yyyy'),
    filterDialog: false,
    activePicker: null
  }),
  computed: {
    ...mapState(["accountInfo"]),
    ...mapState("dashboard", [
      "activePlayerMonthly",
      "activePlayerMonthlyLoading"
    ]),
    ...mapState("dashboard", [
      "playersNewStatistics",
      "playersNewStatisticsLoading"
    ]),

    lowest() {
      const arr = Object.values(this.activePlayerMonthly.active_monthly_statisitcs)
      const filtered_array = arr.filter(val => val != 0)
      
      if (filtered_array.length != 0) return Math.min(...filtered_array)

      return 0
    },

    highest() {
      const arr = Object.values(this.activePlayerMonthly.active_monthly_statisitcs)
      return Math.max(...arr)
    }
  },
  mounted() {
    if (this.accountInfo.access.includes(21)) {
      this.doGetData()
    }
  },
  methods: {
    ...mapActions("dashboard", [
      "getActivePlayerMonthylStatistics"
    ]),
    cancelFilter() {
      this.filterDialog = false
    },
    saveFilter() {
      const expYear = this.year.split("-")
      this.year = expYear[0]
      this.$refs.filterDialog.save(this.year)
      this.doGetData()
    },
    async doGetData() {
      if (!this.cashinMonthlyLoading) {
        this.$store.commit("dashboard/setActivePlayerMonthly", [])

        const formData = new FormData()
        formData.append('val', this.year)
        formData.append('type', 'Monthly')

        const getData = new URLSearchParams(formData)

        await this.getActivePlayerMonthylStatistics(getData)
      }
    },
    moneyFormat(val) {
      return val.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    },
    moneyFormat2(val) {
      return val.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
  },

  watch: {
    filterDialog (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    }
  }
}
</script>